module.exports = __webpack_public_path__ + "img/pg5-fig3-table.4b523097.png";